import { render } from "./TikTokSection.vue?vue&type=template&id=3317fbab"
import script from "./TikTokSection.vue?vue&type=script&lang=js"
export * from "./TikTokSection.vue?vue&type=script&lang=js"

import "./TikTokSection.vue?vue&type=style&index=0&id=3317fbab&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__